export var SubscriptionIntervalEnum;
(function (SubscriptionIntervalEnum) {
    SubscriptionIntervalEnum[SubscriptionIntervalEnum["SEVEN_DAYS"] = 7] = "SEVEN_DAYS";
    SubscriptionIntervalEnum[SubscriptionIntervalEnum["FIFTEEN_DAYS"] = 15] = "FIFTEEN_DAYS";
    SubscriptionIntervalEnum[SubscriptionIntervalEnum["TWENTY_DAYS"] = 20] = "TWENTY_DAYS";
    SubscriptionIntervalEnum[SubscriptionIntervalEnum["THIRTY_DAYS"] = 30] = "THIRTY_DAYS";
    SubscriptionIntervalEnum[SubscriptionIntervalEnum["FORTY_FIVE_DAYS"] = 45] = "FORTY_FIVE_DAYS";
    SubscriptionIntervalEnum[SubscriptionIntervalEnum["SIXTY_DAYS"] = 60] = "SIXTY_DAYS";
    SubscriptionIntervalEnum[SubscriptionIntervalEnum["NINETY_DAYS"] = 90] = "NINETY_DAYS";
})(SubscriptionIntervalEnum || (SubscriptionIntervalEnum = {}));
//# sourceMappingURL=SubscriptionInterval.js.map